import { useTranslation } from "react-i18next";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import PrivacidadeModal from "../Modal/PrivacidadeModal/PrivacidadeModal.jsx";
import TermosModal from "../Modal/TermosModal/TermosModal.jsx";

export default function Contato() {
  const { t } = useTranslation();
  const [showPrivacidadeModal, setShowPrivacidadeModal] = useState(false);
  const [showTermosModal, setShowTermosModal] = useState(false);

  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    assunto: "",
    mensagem: "",
    privacidade: false,
    termos: false
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("enviando");

    emailjs
      .send(
        "service_i1xnbej",
        "template_vtu5pqd",
        formData,
        "kKa0sdf6b2xrjvrWz"
      )
      .then(() => {
        setStatus("sucesso");
        setFormData({
          nome: "",
          email: "",
          telefone: "",
          assunto: "",
          mensagem: "",
          privacidade: false,
          termos: false
        });
      })
      .catch(() => {
        setStatus("erro");
      });
  };

  return (
    <section id="contato" className="section_inicial">
      <h1>{t("contato.titulo")}</h1>
      <p>{t("contato.descricao")}</p>

      <form className="formulario" onSubmit={handleSubmit}>
        <div className="campo-duplo">
          <input
            type="text"
            name="nome"
            autoComplete="name"
            placeholder={t("contato.forms.nome")}
            value={formData.nome}
            onChange={handleChange}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity(t("contato.forms.erroObrigatorio"))
            }
            onInput={(e) => e.target.setCustomValidity("")}
          />
          <input
            type="text"
            name="assunto"
            autoComplete="off"
            placeholder={t("contato.forms.assunto")}
            value={formData.assunto}
            onChange={handleChange}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity(t("contato.forms.erroObrigatorio"))
            }
            onInput={(e) => e.target.setCustomValidity("")}
          />
        </div>

        <div className="campo-duplo">
          <input
            type="email"
            name="email"
            autoComplete="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            onInvalid={(e) => {
              if (e.target.validity.valueMissing) {
                e.target.setCustomValidity(t("contato.forms.erroObrigatorio"));
              } else if (e.target.validity.typeMismatch) {
                e.target.setCustomValidity(t("contato.forms.erroEmail"));
              }
            }}
            onInput={(e) => e.target.setCustomValidity("")}
          />
          <input
            type="tel"
            name="telefone"
            autoComplete="tel"
            placeholder={t("contato.forms.telefone")}
            value={formData.telefone}
            onChange={handleChange}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity(t("contato.forms.erroObrigatorio"))
            }
            onInput={(e) => e.target.setCustomValidity("")}
          />
        </div>

        <textarea
          name="mensagem"
          placeholder={t("contato.forms.mensagem")}
          rows="5"
          value={formData.mensagem}
          onChange={handleChange}
          required
          onInvalid={(e) =>
            e.target.setCustomValidity(t("contato.forms.erroObrigatorio"))
          }
          onInput={(e) => e.target.setCustomValidity("")}
        ></textarea>

        <div className="checkboxes">
          <label>
            <input
              type="checkbox"
              name="privacidade"
              checked={formData.privacidade}
              onChange={handleChange}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity(t("contato.forms.erroCaixa"))
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
            {t("contato.forms.privacidade")}
            <button
              className="button-link"
              onClick={() => setShowPrivacidadeModal(true)}
            >
              {t("footer.direitos.privacidade")}
            </button>
          </label>
          <label>
            <input
              type="checkbox"
              name="termos"
              checked={formData.termos}
              onChange={handleChange}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity(t("contato.forms.erroCaixa"))
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
            {t("contato.forms.termos")}
            <button
              className="button-link"
              onClick={() => setShowTermosModal(true)}
            >
              {t("footer.direitos.termos")}
            </button>
          </label>
        </div>

        <button
          className="enviar"
          type="submit"
          disabled={status === "enviando"}
        >
          {status === "enviando"
            ? t("contato.forms.enviando")
            : t("contato.forms.enviar")}
        </button>

        {status === "sucesso" && (
          <p className="sucesso">{t("contato.forms.enviado")}</p>
        )}
        {status === "erro" && <p className="erro">{t("contato.forms.erro")}</p>}
      </form>
      <PrivacidadeModal
        isOpen={showPrivacidadeModal}
        onClose={() => setShowPrivacidadeModal(false)}
      />
      <TermosModal
        isOpen={showTermosModal}
        onClose={() => setShowTermosModal(false)}
      />
    </section>
  );
}
